/**
 * Normaliserer og bygger `ai_inbox_routing` (samme struktur som API / MailboxAiRoutingActions).
 */

export function defaultAiRoutingForm() {
  return {
    enabled: false,
    provider: "chatgpt",
    model: "gpt-4o-mini",
    promotional: { action: "none", forward_to: "", folder_name: "" },
    order_confirmation: { action: "none", forward_to: "", folder_name: "" },
    customer_inquiry: { action: "none" },
    /** Prosjektkorrespondanse (kjent kunde / fremdrift, avvik): kun logg + valgfritt AI svarutkast — ikke ny kundehenvendelsessak */
    project_correspondence: { action: "none" },
    supplier_cas: {
      action: "none",
      forward_unmatched_to: "",
      cas_reference: "",
      case_number: "",
    },
    case_reply: { action: "none" },
    /** AI-generert svarutkast i Outlook (Graph) etter vellykket kundehenvendelse / sakssvar */
    reply_draft: { enabled: false },
  };
}

function mergeBucket(base, patch) {
  if (!patch || typeof patch !== "object") return { ...base };
  return { ...base, ...patch };
}

export function normalizeAiRouting(air) {
  const d = defaultAiRoutingForm();
  if (!air || typeof air !== "object") return d;

  const en = air.enabled;
  const enabled =
    en === true || ["1", "true", "yes", "on"].includes(String(en ?? "").toLowerCase());

  return {
    enabled: Boolean(enabled),
    provider: String(air.provider || d.provider).toLowerCase() === "grok" ? "grok" : "chatgpt",
    model: air.model != null && air.model !== "" ? String(air.model) : d.model,
    promotional: mergeBucket(d.promotional, air.promotional),
    order_confirmation: mergeBucket(d.order_confirmation, air.order_confirmation),
    customer_inquiry: mergeBucket(d.customer_inquiry, air.customer_inquiry),
    project_correspondence: mergeBucket(d.project_correspondence, air.project_correspondence),
    supplier_cas: mergeBucket(d.supplier_cas, air.supplier_cas),
    case_reply: mergeBucket(d.case_reply, air.case_reply),
    reply_draft: mergeBucket(d.reply_draft, air.reply_draft),
  };
}

function trimOrEmpty(s) {
  return String(s ?? "").trim();
}

/**
 * Objekt klar for PATCH (beholder felt backend kjenner; tomme valgfrie felt kan stå igjen som "").
 */
export function buildAiRoutingPayload(form) {
  const f = normalizeAiRouting(form);
  const out = {
    enabled: f.enabled,
    provider: f.provider,
    promotional: {
      action: f.promotional.action || "none",
      forward_to: trimOrEmpty(f.promotional.forward_to),
      folder_name: trimOrEmpty(f.promotional.folder_name),
    },
    order_confirmation: {
      action: f.order_confirmation.action || "none",
      forward_to: trimOrEmpty(f.order_confirmation.forward_to),
      folder_name: trimOrEmpty(f.order_confirmation.folder_name),
    },
    customer_inquiry: {
      action: f.customer_inquiry.action || "none",
    },
    project_correspondence: {
      action: f.project_correspondence.action || "none",
    },
    supplier_cas: {
      action: f.supplier_cas.action || "none",
      forward_unmatched_to: trimOrEmpty(f.supplier_cas.forward_unmatched_to),
      cas_reference: trimOrEmpty(f.supplier_cas.cas_reference),
      case_number: trimOrEmpty(f.supplier_cas.case_number),
    },
    case_reply: {
      action: f.case_reply.action || "none",
    },
    reply_draft: {
      enabled: Boolean(f.reply_draft?.enabled),
    },
  };

  const m = trimOrEmpty(f.model);
  if (m) out.model = m;

  return out;
}
